import { createSlice } from "@reduxjs/toolkit";
import { fetchPaginationTransactions } from "../transaction/transactionSlice";

const initialState = {
    pagination: {
        limit: 10,
        currentPage: 1,
        pageLength: 1,
    },
    isLoading: false,
    isError: false,
    error: "",
};

export const paginationSlice = createSlice({
    name: "pagination",
    initialState,
    reducers: {
        updateCurrentPage: (state, action) => {
            state.pagination.currentPage = action.payload;
        },
        updatePageLength: (state, action) => {
            state.pagination.pageLength = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPaginationTransactions.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(
                fetchPaginationTransactions.fulfilled,
                (state, actions) => {
                    state.isLoading = false;
                    state.isError = false;
                    state.pagination.pageLength = Math.ceil(
                        actions.payload.transactionsLength /
                            state.pagination.limit
                    );
                }
            )
            .addCase(fetchPaginationTransactions.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error.message;
                state.transactions = [];
            });
    },
});
export const { updateCurrentPage, updatePageLength } = paginationSlice.actions;
export default paginationSlice.reducer;
